import React, { FunctionComponent, useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { assetPathFnState, pageContextState } from '../recoil/atoms';
import { FunnelView } from './views/FunnelView';
import { ModalToggleState, SizingToolState } from '../models/actionStates';
import { isMobileState, modalState, sizingToolState } from '../recoil/selectors';
import { clearHashVariable, getHashVariable } from '../util';
import { SelectionType } from '../enums/SelectionType.enum';
import { useProductSelection } from '../hooks/useProductSelection';
import { PageContext } from '../enums/PageContext.enum';

const SizingToolApp: FunctionComponent = () => {
  const assetPathFn = useRecoilValue(assetPathFnState);
  const [sizingToolUIState, setSizingToolState] = useRecoilState(sizingToolState);
  const setModal = useSetRecoilState(modalState);
  const isMobile = useRecoilValue(isMobileState);
  const { product } = useProductSelection(SelectionType.ProductSection, '0');
  const pageContext = useRecoilValue(pageContextState);

  useEffect(() => {
    preloadImages.forEach((imageUrl) => {
      const image = new Image();
      image.src = assetPathFn(imageUrl);
    });
  }, []);

  useEffect(() => {
    if (getHashVariable('sizing-tool-open') === 'true') {
      clearHashVariable('sizing-tool-open');
      setSizingToolState({
        sizingToolState: SizingToolState.Open,
        selectionType: SelectionType.ProductSection,
        selectionKey: '0',
        product: pageContext === PageContext.ProductPage ? product : undefined,
        initialProduct: PageContext.ProductPage ? product : undefined,
      });
    }
  }, [product, setSizingToolState, pageContext]);

  useEffect(() => {
    switch (sizingToolUIState.sizingToolState) {
      case SizingToolState.Open:
        // if (currentModalState.toggleState === ModalToggleState.Open && !!currentModalState.sizingToolStepKey) {
        //   // This prevents opening another modal when a product is selected on the product selector
        //   return;
        // }
        const modalWidth = isMobile ? '100%' : '70vw';
        const modalHeight = isMobile ? '100%' : '80vh';
        const modalMaxWidth = isMobile ? '100vw' : '80vw';
        const modalMaxHeight = isMobile ? 'unset' : '80vh';

        setModal({
          contents: (
            <FunnelView
              selectionType={sizingToolUIState.selectionType}
              selectionKey={sizingToolUIState.selectionKey}
              subContext={sizingToolUIState.subContext}
            />
          ),
          height: modalHeight,
          width: modalWidth,
          maxWidth: modalMaxWidth,
          maxHeight: modalMaxHeight,
          toggleState: ModalToggleState.Open,
          scrollToTop: false,
          isBaseState: true,
          onClose: () => {
            if (sizingToolUIState.onCloseOverride) {
              sizingToolUIState.onCloseOverride();
            } else {
              setSizingToolState({
                sizingToolState: SizingToolState.Closed,
                selectionKey: sizingToolUIState.selectionKey,
                selectionType: sizingToolUIState.selectionType,
              });
            }
          },
          // sizingToolStepKey: undefined,
        });
        return;
      case SizingToolState.Closed:
        // FIXME: Ideally we would go to base state, but this causes
        // architectural issues as the hook re-renders every time state changes
        // Adding a watch on the return from the hook causes an infinite loop of
        // state updates
        // gotoBaseState();

        setModal({ toggleState: ModalToggleState.Closed });
        return;
      case SizingToolState.ClosedWithoutModalClose:
      default:
        return;
    }
  }, [setModal, sizingToolUIState, isMobile, setSizingToolState]);

  return <></>;
};

const preloadImages = [
  'waist-measurement-illustration.jpg',
  'hip-measurement-illustration.jpg',
  'times-light.svg',
  'chevron-left-light.svg',
  'ico-spb-active.png',
  'ico-sps-active.png',
  'ico-qb-active.png',
  'ico-spt-active.png',
  'ico-lwt-active.png',
];

export default SizingToolApp;
